<template>
    <a-form :form="fenceConfigForm" v-show="fenceConfigStatus == 'process'">

        <div v-if="!editFence">
            <a-button :disabled="fences.length >= 2" @click="addFence()" type="primary">
                <a-icon type="plus"/>
                {{$t('global.create')}}
            </a-button>

            <a-table :columns="fenceCloumns"  :pagination="false" :dataSource="fences" style="margin-top:20px">
                <template slot="forbidType" slot-scope="text">
                    <span v-if="text == 'in'">{{$t('global.forbidIn')}}</span>
                    <span v-if="text == 'out'">{{$t('global.forbidOut')}}</span>
                </template>

                <template slot="fenceType" slot-scope="text">
                    <span v-if="text == 'circle'">{{$t('supervise.circle')}}</span>
                    <span v-if="text == 'polygon'">{{$t('supervise.polygon')}}</span>
                    <span v-if="text == 'district'">{{$t('supervise.district')}}</span>
                </template>

                <template slot="acls" slot-scope="text">
                    <span>{{text ? text : $t('global.none')}}</span>
                </template>

                <template slot="applyAll" slot-scope="text">
                    <a-tag v-if="text" color="blue">{{$t('global.yes')}}</a-tag>
                    <a-tag  v-else color="gray">{{$t('global.no')}}</a-tag>
                </template>

                <template slot="operation" slot-scope="text,record">
                    <a href="javascript:;" @click="deleteFence(record)">{{$t('global.delete')}}</a>
                    <a-divider type="vertical" />
                    <a href="javascript:;" @click="updateFence(record)">{{$t('global.edit')}}</a>
                </template>
            </a-table>

            <div style="margin-top:20px">
                <a-button style="margin-left:10px" @click="gotoPrevious">{{$t('global.pre')}}</a-button>
                <a-button style="margin-left:10px" type="primary" @click="gotoNext">{{$t('global.next')}}</a-button>
            </div>
        </div>

        <div v-else>
            <a-form-item :label="$t('supervise.fenceName')" v-bind="fenceFormItemLayout">
                <a-input size="small" v-model="fenceName" v-decorator="['fenceName',{ rules: [{ required: true, message: $t('supervise.fenceName') }] }]"></a-input>
            </a-form-item>

            <a-form-item :label="$t('supervise.forbidType')" v-bind="fenceFormItemLayout">
                <a-select size="small" v-model="forbidType" v-decorator="['forbidType',{ rules: [{ required: true, message: $t('supervise.forbidType') }] }]">
                    <a-select-option value="in">{{$t('global.forbidIn')}}</a-select-option>
                    <a-select-option value="out">{{$t('global.forbidOut')}}</a-select-option>
                </a-select>
            </a-form-item>

            <a-form-item :label="$t('supervise.fenceType')" v-bind="fenceFormItemLayout">
                <a-select @change="onFenceTypeChange"  size="small" v-decorator="['fenceType',{ rules: [{ required: true, message: $t('supervise.fenceType') }] }]">
                    <a-select-option value="circle">{{$t('supervise.circle')}}</a-select-option>
                    <a-select-option value="polygon">{{$t('supervise.polygon')}}</a-select-option>
                    <a-select-option value="district">{{$t('supervise.district')}}</a-select-option>
                </a-select>
            </a-form-item>

            <a-form-item :label="$t('supervise.center')" v-bind="fenceFormItemLayout" v-show="fenceType == 'circle'">
                <a-input v-model="address" :disabled="true"></a-input>
                <div id="searchResultPanel" style="border:1px solid #C0C0C0;width:150px;height:auto; display:none;"></div>
            </a-form-item>

            <a-form-item :label="$t('supervise.radius')" v-bind="fenceFormItemLayout" v-show="fenceType == 'circle'">
                <a-input-number :min="200" style="width:100%" v-model="radius" @blur="onRadiusChange"></a-input-number>
            </a-form-item>


            <a-form-item :label="$t('supervise.timeOption')" v-bind="fenceFormItemLayout">
                <a-switch size="small" v-model="aclSetting" v-decorator="['aclSetting',{ rules: []}]"></a-switch>
            </a-form-item>

            <a-row :gutter="24" v-if="aclSetting" style="margin-bottom:18px">
                <a-col :span="1"></a-col>
                <a-col :span="21" style="border-left:1px solid #e9eaec;border-right:1px solid #e9eaec;border-bottom:1px solid #e9eaec;">
                    <a-divider orientation="left" style="position:absolute;font-size:12px;margin-top:-9px;margin-left:-12px">{{$t('supervise.timeOption')}}</a-divider>
                    <a-row style="margin-top:15px"/>
                    <a-row>
                        <a-col :span="20" v-for="(item,index) in acls" :key="index">
                            <a-form-item  :validateStatus="item.timeValidateStatus" :help="item.timeErrorMessage" :key="index" :label="$t('supervise.time') + (index + 1)"
                                          v-bind="aclFormItemLayout">
                                <a-row>
                                    <a-col span="20">
                                        <a-time-picker @change="onTimeChange" :secondStep="60" size="small" style="width:40%"
                                                       format="HH:mm"
                                                       v-model="item.startTime"
                                                       :placeholder="$t('supervise.selecteTimeTip')">
                                        </a-time-picker>
                                        <a-input size="small" style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="~" disabled />
                                        <a-time-picker @change="onTimeChange" :secondStep="60" size="small" style="width:40%"
                                                       format="HH:mm"
                                                       v-model="item.endTime"
                                                       :placeholder="$t('supervise.selecteTimeTip')">
                                        </a-time-picker>
                                    </a-col>
                                    <a-col span="4" v-if="index == 0 && acls.length < 3">
                                        <a-button size="small" icon="plus"  @click="addAcl()"></a-button>
                                    </a-col>
                                    <a-col span="4" v-if="index != 0">
                                        <a-button size="small" icon="delete" @click="deleteAcl(index)"></a-button>
                                    </a-col>
                                </a-row>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>

            <a-form-item v-if="fenceType == 'district'" :label="$t('supervise.district')" v-bind="fenceFormItemLayout">
                <a-cascader size="small" placeholder="" v-model="selectRegions"  :options="regions" @change="onRegionChange" :loadData="loadData"  changeOnSelect/>
            </a-form-item>

            <a-form-item  :label="$t('supervise.applyChild')" v-bind="fenceFormItemLayout">
                <a-checkbox v-model="applyAll"></a-checkbox>
            </a-form-item>

            <a-form-item :label="$t('supervise.mapFence')" :validateStatus="fenceValidateStatus" :help="fenceErrorMessage" v-bind="mapFormItemLayout">
                <div style="width:100%;line-height:14px">
                    <div style="width:600px; top: 35px;left: 20px;position: absolute;z-index: 100;background: none">
                        <a-button-group style="width:20%;float:left">
                            <a-button @click="startDrawCircle" :disabled="fenceType != 'circle' || (mkrTool && mkrTool._isOpen)" icon="plus-circle" :title="$t('supervise.circle')"></a-button>
                            <a-button @click="startDrawPolygon" :disabled="fenceType != 'polygon'" icon="plus-square" :title="$t('supervise.polygon')"></a-button>
                        </a-button-group>


                        <span class="ant-input-affix-wrapper" style="width: 75%; float: left; margin-left: 20px;">
                            <span class="ant-input-prefix" style="left:30px">
                                <i class="anticon anticon-search" style="color: rgba(0, 0, 0, 0.25);">
                                    <svg viewBox="64 64 896 896" data-icon="search" width="1em" height="1em" fill="currentColor" aria-hidden="true" class=""><path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0 0 11.6 0l43.6-43.5a8.2 8.2 0 0 0 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"></path>
                                    </svg>
                                </i>
                            </span>
                            <input type="text" id="auto-complete-suggestId" class="ant-input ant-input-search" autocomplete="off" style="width:45%;float:left;margin-left:20px" :disabled="fenceType != 'circle'"/>
                        </span>
                    </div>
                    <BMap @getMap="getMap"  />
                    <!-- <ve-bmap
                            :height="'100%'"
                            :width="'100%'"
                            :settings="chartSettings"
                            :series="chartSeries"
                            :after-set-option-once="afterSet">
                    </ve-bmap> -->
                </div>
            </a-form-item>

            <a-form-item :wrapper-col="{ span: 12, offset: 3 }" style="margin-top:10px">
                <a-button style="margin-left:10px" @click="cancelAdd">{{$t('global.cancel')}}</a-button>
                <a-button style="margin-left:10px" type="primary" @click="addFenceConfirm">{{$t('global.OK')}}</a-button>
            </a-form-item>
        </div>
    </a-form>
</template>

<script>
    import config from '@/config'
    import moment from 'moment'
    import BMap from '@/components/common/BMap'
    import { baiduKey } from '../../config/baiduKey';
    export default {
        name: 'ZAddFenceConfig',
        props:['fenceConfigStatus'],
        components: {
          BMap
        },
        data() {
            return {
                fenceConfigForm: null,
                fenceName: null,
                forbidType: null,
                aclSetting: false,
                fenceType: null,
                // cityListControl: null,
                drawingManager: null,
                mkrTool: null,
                overlays: [],
                regions:[],
                selectRegions:[],
                fences:[],
                bdary: null,
                applyAll: false,
                editFence: false,
                fenceValidateStatus: null,
                fenceErrorMessage: null,
                fenceKey: null,
                radius: null,
                address: null,
                acls: [{
                    "startTime":null,
                    "endTime":null,
                    "timeValidateStatus":"success",
                    "timeErrorMessage":null
                }],
                chartSettings: [],
                chartSeries: [],
                bmap: null,
                fenceFormItemLayout: {
                    labelCol: {
                        xs: { span: 20 },
                        sm: { span: 3 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 14 },
                    }
                },
                mapFormItemLayout:{
                    labelCol: {
                        xs: { span: 20 },
                        sm: { span: 3 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 18 },
                    }
                },
                aclFormItemLayout:{
                    labelCol: {
                        xs: { span: 20 },
                        sm: { span: 4 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 20 },
                    }
                }
            }
        },
        computed: {
          fenceCloumns () {
              return [{
                      title: this.$t('supervise.fenceName'),
                      dataIndex: 'fenceName',
                      key: 'fenceName'
                  },
                  {
                      title: this.$t('supervise.forbidType'),
                      dataIndex: 'forbidType',
                      key: 'forbidType',
                      "scopedSlots": {
                          "customRender": "forbidType"
                      },
                  },
                  {
                      title: this.$t('supervise.timeOption'),
                      dataIndex: 'acl',
                      key: 'acl',
                      "scopedSlots": {
                          "customRender": "acls"
                      },
                  },
                  {
                      title: this.$t('supervise.fenceType'),
                      dataIndex: 'fenceType',
                      key: 'fenceType',
                      "scopedSlots": {
                          "customRender": "fenceType"
                      }
                  },
                  {
                      title: this.$t('supervise.applyChild'),
                      dataIndex: 'applyAll',
                      key: 'applyAll',
                      "scopedSlots": {
                          "customRender": "applyAll"
                      }
                  },
                  {
                      "title": this.$t('global.action'),
                      "dataIndex": "operation",
                      "key": "operation",
                      "scopedSlots": {
                          "customRender": "operation"
                      }
                  }
              ]
            }
        },
        created () {
            this.chartSettings = {
                key: baiduKey,
                bmap: {
                    center: [116.417854, 39.921988],
                    zoom: 18,
                    roam: true,
                    mapStyle: {}
                }
            }
            this.chartSeries = []
        },
        methods:{
          getMap (map) {
            this.bmap = map
            let drawingManager = new window.BMapLib.DrawingManager(this.bmap, {
                    isOpen: false, //是否开启绘制模式
                    enableDrawingTool: false, //是否显示工具栏
                });
                this.drawingManager = drawingManager
                let _this = this
                drawingManager.addEventListener('overlaycomplete', function(e){
                    if(e.drawingMode == 'circle'){
                        //画圆
                        //console.log(e.overlay.getCenter().lat + ',' + e.overlay.getCenter().lng)
                        //console.log(e.overlay.getRadius())
                        _this.circle = e.overlay.getRadius()

                    }else if(e.drawingMode == 'polygon'){
                        //画多边形
                        //console.log(JSON.stringify(e.overlay.getPath()))
                    }
                    _this.clearOverlays();

                    _this.overlays.push(e.overlay)
                    _this.drawingManager.close()
                });
          },
            onRadiusChange(){
                if(this.overlays[0]){
                    let point = this.overlays[0].getCenter()
                    this.clearOverlays();
                    let overlay = new window.BMap.Circle(point,this.radius,{strokeColor:"#7d9ce4", strokeWeight:4, strokeOpacity:0.5});
                    this.bmap.addOverlay(overlay);
                    this.overlays.push(overlay)


                    let points = []
                    points.push({lat:point.lat + this.radius/100000,lng:point.lng})
                    points.push({lat:point.lat - this.radius/100000,lng:point.lng})
                    points.push({lat:point.lat,lng:point.lng + this.radius/100000})
                    points.push({lat:point.lat,lng:point.lng - this.radius/100000})
                    this.bmap.setViewport(points)
                }

            },
            initSearchResultPanel() {
                let _this = this
                let ac = new window.BMap.Autocomplete(    //建立一个自动完成的对象
                    {"input" : "auto-complete-suggestId"
                        ,"location" : this.bmap
                    });
                this.ac = ac
                ac.addEventListener("onhighlight", function(e) {  //鼠标放在下拉列表上的事件
                    var str = "";
                    var _value = e.fromitem.value;
                    var value = "";
                    if (e.fromitem.index > -1) {
                        value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
                    }
                    str = "FromItem<br />index = " + e.fromitem.index + "<br />value = " + value;

                    value = "";
                    if (e.toitem.index > -1) {
                        _value = e.toitem.value;
                        value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
                    }
                    str += "<br />ToItem<br />index = " + e.toitem.index + "<br />value = " + value;
                    document.getElementById("searchResultPanel").innerHTML = str;
                });

                var myValue;
                ac.addEventListener("onconfirm", function(e) {    //鼠标点击下拉列表后的事件
                    var _value = e.item.value;
                    myValue = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
                    document.getElementById("searchResultPanel").innerHTML ="onconfirm<br />index = " + e.item.index + "<br />myValue = " + myValue;
                    _this.setPlace(myValue)
                    _this.address = myValue
                });

            },
            setPlace(myValue){
                let myFun = () => {
                    let pp = local.getResults().getPoi(0).point    //获取第一个智能搜索的结果
                    let point = new window.BMap.Point(pp.lng, pp.lat);
                    this.clearOverlays();
                    let overlay = new window.BMap.Circle(point,this.radius,{strokeColor:"#7d9ce4", strokeWeight:4, strokeOpacity:0.5});
                    this.bmap.addOverlay(overlay);
                    this.overlays.push(overlay)


                    let points = []
                    points.push({lat:pp.lat + this.radius/100000,lng:pp.lng})
                    points.push({lat:pp.lat - this.radius/100000,lng:pp.lng})
                    points.push({lat:pp.lat,lng:pp.lng + this.radius/100000})
                    points.push({lat:pp.lat,lng:pp.lng - this.radius/100000})
                    this.bmap.setViewport(points)
                }
                let local = new window.BMap.LocalSearch(this.bmap, { //智能搜索
                    onSearchComplete: myFun
                })
                local.search(myValue)
            },
            gotoPrevious(){
                this.$emit('gotoPrevious')
            },
            gotoNext(){
                let fenceParam = {}
                fenceParam.data = this.fences
                this.$emit('gotoNext',fenceParam)
            },
            /*
            checkRepeatName(rule,value,callback){
                let len1 = this.fences.length
                let _this = this
                let len2 = this.fences.filter(item =>item.fenceName != value || item.key == _this.fenceKey).length
                if(len1 != len2){
                    callback('围栏名称已经存在！');
                }else{
                    callback();
                }
            },
            */
            init(){
                this.fences = []
                this.aclSetting = false
                this.acls = [{
                    "startTime":null,
                    "endTime":null,
                    "timeValidateStatus":"success",
                    "timeErrorMessage":null
                }]
                this.editFence = false
                this.fenceConfigForm = this.$form.createForm(this)
                let _this = this
                this.$http.post(config.api.get_all_province_id).then((response) => {
                    if(response.code == 0){
                        _this.regions = []
                        response.result.map(function(item){
                            _this.regions.push({
                                value: item.id + ',' + item.name,
                                label: item.name,
                                isLeaf: false,
                            })
                        })
                    }
                }).catch((err) => {
                    console.log(err)
                })
            },
            cancelAdd(){
                this.drawingManager.close()
                this.fenceType = ''
                this.editFence = false
                this.clearOverlays()
            },
            deleteFence(fence){
                this.fences.splice(fence.key,1)
            },
            updateFence(fence){
                this.editFence = true
                this.fenceKey = fence.key
                this.fenceName = fence.fenceName
                this.forbidType = fence.forbidType
                this.fenceType = fence.fenceType
                this.acls = []
                let _this = this
                let aclSetting = false
                if(fence.acls != null && fence.acls != ''){
                    let items = fence.acls.split('/')
                    items.map(function(item){
                        let startTime = item.split('~')[0]
                        let startHour = parseInt(startTime.split(':')[0])
                        let startMinute = parseInt(startTime.split(':')[1])
                        let start = moment(moment().startOf('day').valueOf() + (startHour * 60 + startMinute) * 60 * 1000)
                        let endTime = item.split('~')[1]
                        let endHour = parseInt(endTime.split(':')[0])
                        let endMinute = parseInt(endTime.split(':')[1])
                        let end = moment(moment().startOf('day').valueOf() + (endHour * 60 + endMinute) * 60 * 1000)
                        _this.acls.push({
                            "startTime":start,
                            "endTime":end,
                            "timeValidateStatus":"success",
                            "timeErrorMessage":null
                        })
                    })
                    aclSetting = true
                }else{
                    this.acls = [{
                        "startTime":null,
                        "endTime":null,
                        "timeValidateStatus":"success",
                        "timeErrorMessage":null
                    }]
                }
                this.selectRegions = fence.regions

                setTimeout(() => {
                    _this.fenceConfigForm.setFieldsValue({
                        fenceName: fence.fenceName
                    });
                    _this.fenceConfigForm.setFieldsValue({
                        forbidType: fence.forbidType
                    });
                    _this.fenceConfigForm.setFieldsValue({
                        fenceType: fence.fenceType
                    });
                    _this.fenceConfigForm.setFieldsValue({
                        aclSetting: aclSetting
                    });
                    _this.aclSetting = aclSetting
                },200)

                this.top = this.getScrollTop()
                if (this.top) {
                    this.setScrollTop(0)
                }

                // if(this.cityListControl){
                //     this.bmap.removeControl(_this.cityListControl);
                // }
                setTimeout(() => {
                    _this.initSearchResultPanel();
                    _this.radius = 5000
                    _this.address = null
                    if(fence && fence.fenceType == 'circle'){
                        _this.radius = fence.overlays[0].getRadius().toFixed()

                        var pt = new window.BMap.Point(fence.overlays[0].getCenter().lng,fence.overlays[0].getCenter().lat)
                        var geoc = new window.BMap.Geocoder()
                        geoc.getLocation(pt, function (rs) {
                            if (rs.address !== '') {
                                _this.address  = rs.address;
                            }else {
                                if ((rs.addressComponents.city !== '') && (rs.addressComponents.country !== '')) {
                                    _this.address  = rs.addressComponents.city + ', ' + rs.addressComponents.country;
                                }
                            }
                        })
                    }
                    // var size = new window.BMap.Size(10, 20);
                    // _this.cityListControl = new window.BMap.CityListControl({
                    //     anchor: window.BMAP_ANCHOR_TOP_RIGHT,
                    //     offset: size,
                    // })
                    // _this.bmap.addControl(_this.cityListControl);

                    if(!_this.bdary){
                        _this.bdary = new window.BMap.Boundary()
                    }

                    _this.overlays = fence.overlays
                    fence.overlays.map(function(item){
                        _this.bmap.addOverlay(item)
                    })
                    if(fence.fenceType == 'circle'){
                        let points = []
                        let lat = fence.overlays[0].getCenter().lat
                        let lng = fence.overlays[0].getCenter().lng
                        let radius = fence.overlays[0].getRadius()
                        points.push({lat:lat + radius/100000,lng:lng})
                        points.push({lat:lat - radius/100000,lng:lng})
                        points.push({lat:lat,lng:lng + radius/100000})
                        points.push({lat:lat,lng:lng - radius/100000})
                        _this.bmap.setViewport(points)
                    }
                    if(fence.fenceType == 'polygon'){
                        _this.bmap.setViewport(fence.overlays[0].getPath())
                    }
                    if(fence.fenceType == 'district'){
                        _this.district = fence.regions
                        let points = []
                        fence.overlays.map(function(overlay){
                            points.push(...overlay.getPath())
                        })
                        _this.bmap.setViewport(points);
                    }

                    _this.mkrTool = new window.BMapLib.MarkerTool( _this.bmap, {autoClose: true, followText: ""})
                    _this.mkrTool.addEventListener("markend", function(e) {
                        _this.bmap.removeOverlay(e.marker)
                        _this.clearOverlays();
                        let overlay = new window.BMap.Circle(e.marker.point,_this.radius,{strokeColor:"#7d9ce4", strokeWeight:4, strokeOpacity:0.5});
                        _this.bmap.addOverlay(overlay);
                        _this.overlays.push(overlay)
                        var geoc = new window.BMap.Geocoder()
                        var pt = new window.BMap.Point(e.marker.point.lng,e.marker.point.lat)
                        geoc.getLocation(pt, function (rs) {
                            if (rs.address !== '') {
                                _this.address  = rs.address;
                            }else {
                                if ((rs.addressComponents.city !== '') && (rs.addressComponents.country !== '')) {
                                    _this.address  = rs.addressComponents.city + ', ' + rs.addressComponents.country;
                                }
                            }
                        })

                        let points = []
                        let lat  = e.marker.point.lat
                        let lng  = e.marker.point.lng
                        let radius = _this.radius
                        points.push({lat:lat + radius/100000,lng:lng})
                        points.push({lat:lat - radius/100000,lng:lng})
                        points.push({lat:lat,lng:lng + radius/100000})
                        points.push({lat:lat,lng:lng - radius/100000})
                        _this.bmap.setViewport(points)
                    })
                },500)
            },
            clearOverlays(){
                if(this.overlays && this.overlays.length > 0){
                    let _this = this
                    this.overlays.map(function(item){
                        _this.bmap.removeOverlay(item)
                    })
                    this.overlays = []
                }
            },
            addFence(){
                this.aclSetting = false
                this.fenceKey = null
                this.applyAll = false
                this.acls = [{
                    "startTime":null,
                    "endTime":null,
                    "timeValidateStatus":"success",
                    "timeErrorMessage":null
                }]
                this.editFence = true
                this.selectRegions = null

                let  _this = this
                this.top = this.getScrollTop()
                if (this.top) {
                    this.setScrollTop(0)
                }

                // if(this.cityListControl){
                //     this.bmap.removeControl(_this.cityListControl);
                // }
                _this.radius = 5000
                this.address = null
                setTimeout(() => {
                    _this.initSearchResultPanel();
                    // var size = new window.BMap.Size(10, 20);
                    // _this.cityListControl = new window.BMap.CityListControl({
                    //     anchor: window.BMAP_ANCHOR_TOP_RIGHT,
                    //     offset: size,
                    // })
                    // _this.bmap.addControl(_this.cityListControl);

                    if(!_this.bdary){
                        _this.bdary = new window.BMap.Boundary()
                    }
                    _this.mkrTool = new window.BMapLib.MarkerTool( _this.bmap, {autoClose: true, followText: ""})
                    _this.mkrTool.addEventListener("markend", function(e) {
                        _this.bmap.removeOverlay(e.marker)
                        _this.clearOverlays();
                        let overlay = new window.BMap.Circle(e.marker.point,_this.radius,{strokeColor:"#7d9ce4", strokeWeight:4, strokeOpacity:0.5});
                        _this.bmap.addOverlay(overlay);
                        _this.overlays.push(overlay)
                        var geoc = new window.BMap.Geocoder()
                        var pt = new window.BMap.Point(e.marker.point.lng,e.marker.point.lat)
                        geoc.getLocation(pt, function (rs) {
                            if (rs.address !== '') {
                                _this.address  = rs.address;
                            }else {
                                if ((rs.addressComponents.city !== '') && (rs.addressComponents.country !== '')) {
                                    _this.address  = rs.addressComponents.city + ', ' + rs.addressComponents.country;
                                }
                            }
                        })

                        let points = []
                        let lat  = e.marker.point.lat
                        let lng  = e.marker.point.lng
                        let radius = _this.radius
                        points.push({lat:lat + radius/100000,lng:lng})
                        points.push({lat:lat - radius/100000,lng:lng})
                        points.push({lat:lat,lng:lng + radius/100000})
                        points.push({lat:lat,lng:lng - radius/100000})
                        _this.bmap.setViewport(points)
                    })
                },500)
            },
            onRegionChange(region){
                this.selectRegions = region
                if(region && region.length > 0){
                    let _this = this
                    this.bdary.get(region[region.length - 1].split(',')[1], function(rs){       //获取行政区域
                        _this.clearOverlays();
                        var count = rs.boundaries.length; //行政区域的点有多少个
                        let points = []
                        for(var i = 0; i < count; i++){
                            let overlay =  new window.BMap.Polygon(rs.boundaries[i], {strokeWeight: 4, strokeColor: "#7d9ce4"}); //建立多边形覆盖物
                            _this.bmap.addOverlay(overlay);  //添加覆盖物
                            _this.overlays.push(overlay)
                            points.push(...overlay.getPath())
                            _this.bmap.setViewport(points);
                        }
                    });
                }else{
                    this.clearOverlays();
                }
            },
            loadData(selectedOptions){
                const targetOption = selectedOptions[selectedOptions.length - 1]
                targetOption.loading = true
                let _this = this
                let param = {}
                param.id = targetOption.value.split(',')[0]
                this.$http.post(config.api.get_all_province_id, param).then((response) => {
                    if(response.code == 0){
                        targetOption.loading = false;
                        targetOption.children = []
                        response.result.map(function(item){
                            targetOption.children.push({
                                value: item.id + ',' + item.name,
                                label: item.name,
                                isLeaf: item.level < 3 ? false : true
                            })
                        })
                        _this.regions = [..._this.regions]
                    }
                }).catch((err) => {
                    console.log(err)
                })
            },
            getScrollTop () {
                let scrollTop = 0;
                if (document.documentElement && document.documentElement.scrollTop) {
                    scrollTop = document.documentElement.scrollTop;
                } else if (document.body) {
                    scrollTop = document.body.scrollTop;
                }
                return scrollTop;
            },
            setScrollTop (top) {
                if (!isNaN(top)) {
                    if (document.documentElement && document.documentElement.scrollTop !== undefined) {
                        document.documentElement.scrollTop = top;
                    } else if (document.body) {
                        document.body.scrollTop = top;
                    }
                }
            },
            startDrawCircle(){
                //this.drawingManager.setDrawingMode(window.BMAP_DRAWING_CIRCLE)
                //this.drawingManager.open()
                this.mkrTool.open()
            },
            startDrawPolygon(){
                this.drawingManager.setDrawingMode(window.BMAP_DRAWING_POLYGON)
                this.drawingManager.open()
            },
            afterSet: function (echarts) {
                this.bmap = echarts.getModel().getComponent('bmap').getBMap()

                let drawingManager = new window.BMapLib.DrawingManager(this.bmap, {
                    isOpen: false, //是否开启绘制模式
                    enableDrawingTool: false, //是否显示工具栏
                });
                this.drawingManager = drawingManager
                let _this = this
                drawingManager.addEventListener('overlaycomplete', function(e){
                    if(e.drawingMode == 'circle'){
                        //画圆
                        //console.log(e.overlay.getCenter().lat + ',' + e.overlay.getCenter().lng)
                        //console.log(e.overlay.getRadius())
                        _this.circle = e.overlay.getRadius()
                    }else if(e.drawingMode == 'polygon'){
                        //画多边形
                        //console.log(JSON.stringify(e.overlay.getPath()))
                    }
                    _this.clearOverlays();

                    _this.overlays.push(e.overlay)
                    _this.drawingManager.close()
                });
            },
            addFenceConfirm(){
                let _this = this
                this.fenceConfigForm.validateFieldsAndScroll((err) => {
                    if (!err) {
                        let acls = null
                        if(_this.aclSetting){
                            acls = ''
                            let validFlag = true
                            _this.acls.map(function(item){
                                if(!item.startTime || !item.endTime){
                                    validFlag = false
                                    item.timeValidateStatus = 'error'
                                    item.timeErrorMessage = '请设置时间'
                                    setTimeout(function(){
                                        item.timeValidateStatus = "success"
                                        item.timeErrorMessage = null
                                    },5000)
                                    return
                                }else{
                                    acls  += item.startTime.format("HH:mm") + '~' + item.endTime.format("HH:mm") + '/'
                                }
                            })
                            if(!validFlag){
                                return
                            }
                            acls = acls.substring(0,acls.length - 1)
                        }
                        if(_this.overlays.length == 0){
                            _this.fenceValidateStatus = 'error'
                            _this.fenceErrorMessage = '请设置围栏'
                            setTimeout(function(){
                                _this.fenceValidateStatus = "success"
                                _this.fenceErrorMessage = null
                            },5000)
                            return
                        }

                        if(_this.fenceKey == null){
                            _this.fences.push({
                                applyAll: _this.applyAll,
                                key: _this.fences.length,
                                fenceName:_this.fenceName,
                                forbidType: _this.forbidType,
                                acls: acls,
                                fenceType: _this.fenceType,
                                overlays: _this.overlays,
                                regions: _this.selectRegions
                            })
                        }else{
                            _this.fences[_this.fenceKey] = {
                                applyAll: _this.applyAll,
                                key: _this.fenceKey,
                                fenceName:_this.fenceName,
                                forbidType: _this.forbidType,
                                acls: acls,
                                fenceType: _this.fenceType,
                                overlays: _this.overlays,
                                regions: _this.selectRegions
                            }
                        }
                        _this.clearOverlays();
                        _this.editFence = false
                    }
                })
            },
            onTimeChange(selectTime){
                if(selectTime){
                    // selectTime = moment(selectTime.startOf('minute').valueOf())
                    selectTime = selectTime.unix()
                    // console.log(selectTime)
                }
            },
            onFenceTypeChange(value){
                this.selectRegions = []
                this.fenceType = value
                this.clearOverlays();
            },
            addAcl() {
                this.acls.push({
                    startTime:null,
                    endTime:null
                })
            },
            deleteAcl(index) {
                this.acls.splice(index, 1);
            }
        }
    }
</script>